import {ADD_CONTACT_TO_DELETE} from "./_mutations";


export default {

};
